import { bffApi } from "../../../../../services/bff/bffApi";
import { BaseService } from "../../../../../global/classes";
import { FormValuesHistory } from "../types";

export default class HistoryAnticipationService extends BaseService {
  getHistoryAnticipation = async (
    page: number,
    pageSize: number,
    filter?: FormValuesHistory
  ) => {
    const paged = true;
    const initDate = filter?.initDate || null;
    const finishDate = filter?.finishDate || null;
    const merchantId = this.selectedCompany?.merchantId ?? filter?.merchantId ?? null;
    const commercialHierId = null;
    const commercialUserEmail = this.commercialUserEmail;

    return bffApi.get(
      `/api/gcb/v1/anticipation/geral-anticipation-history`,
      {
        params: {
          currentPage: page,
          pageSize: pageSize,
          paged: paged,
          initDate: initDate,
          finishDate: finishDate,
          merchantId: merchantId,
          commercialHierId: commercialHierId,
          email: commercialUserEmail,
        },
      }
    )
  };

  downloadHistoryAnticipationXls = async (filter?: FormValuesHistory) => {
    const paged = false;
    const initDate = filter?.initDate || null;
    const finishDate = filter?.finishDate || null;
    const merchantId = this.selectedCompany?.merchantId ?? filter?.merchantId ?? null;
    const commercialUserEmail = this.commercialUserEmail;

    try {
      const response = await bffApi.get(
        `/api/gcb/v1/anticipation/geral-anticipation-history-xls`, {
        params: {
          paged: paged,
          initDate: initDate,
          finishDate: finishDate,
          merchantId: merchantId,
          forDownload: true,
          email: commercialUserEmail,
        },
        responseType: "blob",
      }
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  };
}
